import { Link, useLocation } from 'react-router-dom'

import AdminViewIcon from '@/assets/icons/admin-view.svg?react'
import MemberViewIcon from '@/assets/icons/member-view.svg?react'
import { Trans } from '@/components'
import { cn } from '@/utils/style'

export function DataViewSwitcher() {
  const location = useLocation()
  // Admin View or Shared View (accessed from Admin) both count as Admin perspective
  const isAdminView =
    location.pathname.includes('/team/data/admin') ||
    location.pathname.includes('/team/data/shared')

  return (
    <div className="bg-neutral-50 p-1 rounded-xl flex gap-1">
      <Link
        to="/team/data/member"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          !isAdminView
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
      >
        <MemberViewIcon className="w-5 h-5" />
        <span>
          <Trans i18nKey="common.viewSwitcher.memberView">Member View</Trans>
        </span>
      </Link>
      <Link
        to="/team/data/admin"
        className={cn(
          'flex items-center gap-1 px-4 py-2 rounded-lg transition-colors t-x-sb',
          isAdminView
            ? 'bg-highlight/10 text-highlight'
            : 'bg-neutral-50 text-primary hover:bg-neutral-200',
        )}
      >
        <AdminViewIcon className="w-5 h-5" />
        <span>
          <Trans i18nKey="common.viewSwitcher.adminView">Admin View</Trans>
        </span>
      </Link>
    </div>
  )
}
